export const CLEAR_COMMENTS = 'comments/CLEAR';

export const clearComments = postId => ({
  type: CLEAR_COMMENTS,
  payload: { postId },
});
